import React from "react";
import { Link, Outlet } from "react-router-dom";
import { Brand } from "./AppShell";
import { useAuth } from "../../context/AuthContext";
import { PublicBg } from "../lux";

export default function PublicLayout() {
  const { isLoggedIn } = useAuth();
  return (
    <div className="public public--wall">
      <PublicBg ids={["07", "393", "63", "373", "14", "432", "37", "394"]} />
      <div className="public__bar">
        <Brand />
        {isLoggedIn ? <Link className="btn btn--sm" to="/">เข้าแอป</Link> : <Link className="btn btn--sm btn--ghost" to="/login">เข้าสู่ระบบ</Link>}
      </div>
      <Outlet />
    </div>
  );
}
